<template>
  <div>
    <BaseModal :config="DistributionModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
      <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">       
        <form ref="refDistributionForm" id="DistributionForm" action>        
          <div id="pageErrors" class="alert alert-danger"  v-if="pageErrors.length>0">
            <p >
            <b >Please correct the following error(s):</b>
            <ul >
            <li  v-for="error in pageErrors" :key="error">{{ error }}</li>
            </ul>
            </p>
          </div>
          <div
            id="Customerror"
            class="alert alert-danger"
            role="alert"
            v-show="customerrors.length && !errors.items.length"
          >
            <span v-show="customerrors.length" class="alert-danger">
             <b>Please correct the following error(s):</b>
            <ul>
            <li v-for="error in customerrors" :key=error>{{ error }}</li>
            </ul>
            </span>
          </div>

          
 			<div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Program</label>              
              <div class="input-group mb-3 pl-0">
                <kendo-autocomplete
                  id="SearchProgram"
                  class="form-control"
                  name="Program"				  
                  v-model="ProgramAutoCompleteDisplayedValue"
                  :data-source="ProgramAutoCompleteSource"
                  :data-text-field="'Title'"
                  :filter="'contains'"
                  :placeholder="'Search for Program'"
                  @select="onProgramAutoCompleteSelect"
                  @open="onProgramOpen"
                  @close="onProgramClose"
                ></kendo-autocomplete>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
              
            </div>
			<div class="form-group col-md-6">
              <label class="required-label">Partner</label>              
              <div class="input-group mb-3 pl-0">
                <kendo-autocomplete
                  id="SearchPartner"
                  name="Partner"
                  class="form-control"
                  v-model="PartnerAutoCompleteDisplayedValue"
                  :data-source="PartnerAutoCompleteSource"
                  :data-text-field="'FullName'"
                  :filter="'contains'"
                  :placeholder="'Search for Partner'"
                  @select="onPartnerAutoCompleteSelect"
                  @open="onPartnerOpen"
                  @close="onPartnerClose"
                ></kendo-autocomplete>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>                       
          </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Type of Distribution 1</label> 
              <div id="kendo-select">
                <kendo-dropdownlist v-model="DistributionInfo.DistributionType1"
                            :data-source="DistributionType1Options"
                            :data-text-field="'Option'"
                            :option-label="'Select Distribution 1 Type'"
                            :data-value-field="'Option'">
                </kendo-dropdownlist>   
              </div>
              <!-- <select v-model="DistributionInfo.DistributionType1"  class="form-control">
              <option value selected>Select Distribution 1 Type</option>      
              <option
                v-for="option in DistributionType1Options"
                :key="option.Id"
                :value="option.Option"
              >{{option.Option}}</option> 
              </select>  -->
              
            </div>
			<div class="form-group col-md-6">
              <label class="required-label">Type of Distribution 2</label> 
              <div id="kendo-select">
                <kendo-dropdownlist v-model="DistributionInfo.DistributionType2"
                            :data-source="DistributionType2Options"
                            :data-text-field="'Option'"
                            :option-label="'Select Distribution 2 Type'"
                            :data-value-field="'Option'">
                </kendo-dropdownlist>   
              </div>
              <!-- <select v-model="DistributionInfo.DistributionType2"  class="form-control">
              <option value selected>Select Distribution 2 Type</option>      
              <option
                v-for="option in DistributionType2Options"
                :key="option.Id"
                :value="option.Option"
              >{{option.Option}}</option> 
              </select>  -->
              
            </div>
          </div>

           

          <div class="form-row">
            <div class="form-group col-md-6"> 
            <label class="required-label">Type of Partner</label> 
            <div id="kendo-select">
                <kendo-dropdownlist v-model="DistributionInfo.DistributionPartnerType"
                            :data-source="DistributionPartnerTypeOptions"
                            :data-text-field="'Option'"
                            :option-label="'Select Partner Type'"
                            :data-value-field="'Option'">
                </kendo-dropdownlist>   
            </div>
              <!-- <select v-model="DistributionInfo.DistributionPartnerType"  class="form-control">
              <option value selected>Select Partner Type</option>      
              <option
                v-for="option in DistributionPartnerTypeOptions"
                :key="option.Id"
                :value="option.Option"
              >{{option.Option}}</option> 
              </select>                    -->
            </div>
            <div class="form-group col-md-6"> 
              <label class="required-label">Distribution Date</label>              
              <div class="input-group">
                    <kendo-datepicker
                      placeholder="Select Date"  
                      :value='DistributionInfo.DistributionDate'
                      v-model='DistributionInfo.DistributionDate'
                       :format="'MM/dd/yyyy'" 
                       id="dtDistributionDate"
							             width="100%"   
                        @open="_setCurrentDateifNull"
                        >
                       </kendo-datepicker>
                </div>               
            </div>				
          </div>  
          <div class="form-row">
            <div class="form-group col-md-6"> 
              <label class="required-label">Distribution Amount</label>              
              <input
                type="number"
                id="txtDistributionAmount"                               
                v-model="DistributionInfo.DistributionAmount"
                class="form-control"
                placeholder="Distribution Amount"
              >                 
            </div>				
          </div> 
          <div class="form-row">
          <div class="form-group col-md-12">
              <label>Notes/Comments</label>		
              <textarea class="form-control" rows="4" cols="50" id="txtNote" placeholder="Notes/Comments" v-model="DistributionInfo.Note"></textarea>
          </div>
        </div>

        </form>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import $ from "jquery";
import BaseModal from "@/components/base/BaseModal.vue";
import apiUtil from "@/services/apiUtil.js";
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelDistribution from "@/models/BaseModelDistribution.js";
import moment from "moment";
import funcUtil from "@/services/funcUtil.js";
import ValuationMixin from "@/mixins/ValuationMixin.js"
import BaseGrid from "@/components/base/BaseGrid.vue";
import {mapGetters, mapActions, mapState } from 'vuex';
import { isNullOrUndefined } from "util";

export default {
  name: "DistributionForm",
  props: {
    DistributionInfo: {},
    DistributionModalLabel: {},    
    ProgramUnitClassJsonData: {}
  },
  mixins: [apiUtil, funcUtil,ValuationMixin],
  computed: {
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
     
  },
  data: function() {
    return {
      BaseModelDistribution: BaseModelDistribution,      
      BaseModelProgram: BaseModelProgram,
      BaseModelPartner: BaseModelPartner,      
      
      displayErrors: false,
      BaseModelInputControl: BaseModelInputControl,
      dropdowns: {
        DistributionType1: { model: "", dataSource: [] }, 
        DistributionType2: { model: "", dataSource: [] }, 
        DistributionPartnerType: { model: "", dataSource: [] },              
      },
      customerrors:[],            
      DistributionType1Options:[],
      DistributionType2Options:[],      
      DistributionPartnerTypeOptions:[],
      pageErrors : [],
      ProgramAutoCompleteSource: [],
      PartnerAutoCompleteSource: [],
      PartnerAutoCompleteDisplayedValue:"",
      ProgramAutoCompleteDisplayedValue:"",
      bProgramValid:true,
      bPartnerValid:true
      // ProgramUnitClassJsonData:[],
      // programAutoCompleteDisplayedValue:"",
      // partnerAutoCompleteDisplayedValue:"",
    };
  },
  methods: {
      ...mapActions("postModule",['UpdateItems','CreateItems']),

    onProgramAutoCompleteSelect(e) {
      this.bProgramValid=true;
      this.DistributionInfo.ProgramId = e.dataItem.Id;
      this.DistributionInfo.ProgramTitle = e.dataItem.Title; 
      this.DistributionInfo.ProgramProgramID = e.dataItem.ProgramID; 
    },
    onProgramOpen(){
      this.bProgramValid=false;
    },
    onProgramClose(){
      if (!this.bProgramValid) {
        this.DistributionInfo.ProgramId = null;
        this.DistributionInfo.ProgramTitle = null;
      }
    },
    onPartnerAutoCompleteSelect(e) {  
      this.bPartnerValid=true;  
      this.DistributionInfo.PartnerId = e.dataItem.Id;
      this.DistributionInfo.PartnerFullName = e.dataItem.FullName;
      this.DistributionInfo.PartnerPartnerID = e.dataItem.PartnerID; 
    },
    onPartnerOpen(){
      this.bPartnerValid=false;
    },
    onPartnerClose(){
      if (!this.bPartnerValid) {
        this.DistributionInfo.PartnerId = null;
        this.DistributionInfo.PartnerFullName = null;
      }
    },
    Validate(){
            const self=this;
            self.pageErrors = [];
            let bDuplicateCheckFields = false, bDuplicateYearQuarter= false;
            let form=self.DistributionInfo;
        //Form Validation
            if (!(form.PartnerId && form.PartnerFullName)) {
                self.pageErrors.push('Partner is required');
            }
            if (!(form.ProgramId && form.ProgramTitle)) {
                self.pageErrors.push("Program is required");
            }
            if (!form.DistributionType1) {
                self.pageErrors.push('Type of Distribution 1 is required');
            }
            if (!form.DistributionType2) {
                self.pageErrors.push("Type of Distribution 2 is required");
            }
            if (!form.DistributionPartnerType) {
                self.pageErrors.push('Type of Partner is required');
            }
            if (!form.DistributionDate) {
                self.pageErrors.push("Distribution Date is required");
            }
            if (!form.DistributionAmount) {
                self.pageErrors.push("Distribution Amount is required");
            }
            if (self._validateSpecialCharacter(form.Note,"multiline")) {
                self.pageErrors.push(`Note cannot have ${this.MultiLineSpecialChars}  Characters`);
            }       

        //Validation failed or success
            return self.pageErrors.length>0 ? false:true
    },
    
     getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
    //   self._getInputControls().then(response => {
        console.log(response);
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          // self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });

        //Filling the Drop down options for the Grid DropDown Columns        
        this.DistributionType1Options=this.dropdowns.DistributionType1.dataSource;
        this.DistributionType2Options=this.dropdowns.DistributionType2.dataSource; 
        this.DistributionPartnerTypeOptions=this.dropdowns.DistributionPartnerType.dataSource;
    //   });
    },
         
    // saveChanges: function(e) {
    //   let self=this;
    //   this.displayErrors = true;
     
    //     if (self.Validate()) {
    //       if (this.DistributionModalLabel.modalAddorEdit == "add") {
    //         // Add Popup                  
    //         console.log(JSON.stringify(this.DistributionInfo));            
    //         let addFormValues = this.DistributionInfo; 
    //         addFormValues.DistributionAmount = parseInt(addFormValues.DistributionAmount);            
    //         let createItem = { list:this.BaseModelDistribution, payload:addFormValues };
    //         let loader = this.$loading.show();
    //         this.CreateItems(createItem).then((res) => {
    //             loader.hide();
    //             self.$emit("SaveComplete",e);
    //             self._AlertPopup("Data Saved Successfully!","success");
    //             // $("#BaseModal").modal("toggle");                
    //             self.resetFields();
    //         });
            
    //       } else {
    //         // Edit Popup             
    //         console.log(JSON.stringify(this.DistributionInfo));
    //         var editFormValues = this.DistributionInfo;
    //         editFormValues.DistributionAmount = parseInt(editFormValues.DistributionAmount);
    //         let updateItem = { list:this.BaseModelDistribution, payload:editFormValues };
    //         let loader = this.$loading.show();
    //         this.UpdateItems(updateItem).then((res) => {
    //             loader.hide();
    //             self.$emit("SaveComplete",e);
    //             self._AlertPopup("Data Saved Successfully!","success");
    //             // $("#BaseModal").modal("toggle");
    //             self.resetFields();
    //         });
            
    //       }
    //       $("#BaseModal").modal("toggle");
            
    //     }
    //     else{
    //       // $('#pageErrors').focus();
    //       let basemodal = $("#BaseModal");
    //       $("input:text:visible:first", basemodal).focus();
    //     }
    //     // });
    //   // }      
    // },
    // resetFields: function() {
    //   // let self=this;
    //   //  this.$refs.refProgramForm.$refs.ProgramForm.reset();
    //   this.displayErrors = false;
    //   this.errors.clear();
    //   this.customerrors=[];
    // },  
    saveChanges: function(e) {
      let self=this;
      this.displayErrors = true;
     
        if (self.Validate()) {          
          this.DistributionInfo.DistributionAmount = parseFloat(this.DistributionInfo.DistributionAmount);    
          this._saveChangesValuation(this.DistributionModalLabel.modalAddorEdit,this.DistributionInfo,this.BaseModelDistribution);          
        }
        else{
          // $('#pageErrors').focus();
          let basemodal = $("#BaseModal");
          $("input:text:visible:first", basemodal).focus();
        }
        // });
      // }      
    },
    resetFields: function() {     
      this._resetFieldsValuation();
    },    
   
    getProgramAutoCompleteData() {    

    //   this._getItems(BaseModelProgram).then(response => {
    //     this.ProgramAutoCompleteSource = response;
    //   });

      this.ProgramAutoCompleteSource = this.withFilter(BaseModelProgram.list);

    },
    getPartnerAutoCompleteData() {
    //   this._getItems(BaseModelPartner).then(response => {
    //     this.PartnerAutoCompleteSource = response;
    //   });
let partnerFilterQuery ={
		batchQuery:true,
        filter : function(o){
            return o.PartnerStatus !='Retired Employee' && o.PartnerStatus !='Former Employee'
        },
		limit: 5000
	}
    
    this.PartnerAutoCompleteSource = this.withFilter(BaseModelPartner.list,partnerFilterQuery);
    },
  },
  mounted() {
     this.getInputControls();

    // alert(JSON.stringify(this.ProgramInfoFormConfig));
    this.resetFields();
    // this.getProgramAutoCompleteData();
    // this.getPartnerAutoCompleteData();

    $("#BaseModal").on("shown.bs.modal", function() {
      $("input:text:visible:first", this).focus();
    });

    //For Displaying List on Focus
    this.ShowAutoCompleteListOnFocus("SearchProgram");
    this.ShowAutoCompleteListOnFocus("SearchPartner");
    // $("#dtDistributionDate").on("change",this.DistributionDateChanged);
  },
  components: {
    BaseModal,    
  }
};
</script>
<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}

/* input[type="radio"]{
  width: 22px;
  margin-top: 4px;
}*/
/* .addButtonClass{
  /* margin-left:70%; 
} */
</style>
